import {useState, useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {ColectorService} from "saneamiento/service";
import {useColectorData} from "../hooks/ColectorData";
import {PageLayout} from "base/layout";
import {ColectorSubPageMenu} from "../menu";
import {useAppConfig} from "base/provider";
import {EntityPrintPDFAction} from "base/entity";

const ViewColectorPage = () => {
    const {setSubpagePath, setModuleActions} = useAppConfig();

    const {idColector} = useParams();
    const [colector, setColector] = useState(null);
    const location = useLocation();
    const {getEntityData} = useColectorData();

    useEffect(() => {
        ColectorService.get(idColector).then(data => {
            setColector(data);
            setSubpagePath([
                {name: "Listado de Colectores", path: "colectores"},
                {
                    name: data.nome || data.codigo || data.id,
                    path: `${data.id}/summary`,
                },
            ]);
            setModuleActions([
                <EntityPrintPDFAction entityData={getEntityData(data)} />,
            ]);
        });
        return () => {
            setColector(null);
            setSubpagePath([]);
            setModuleActions([]);
        };
    }, [idColector, location.state?.lastRefreshDate]);

    return (
        colector && (
            <PageLayout
                menu={<ColectorSubPageMenu colector={colector} />}
                context={[colector]}
                subPage={true}
            />
        )
    );
};

export default ViewColectorPage;
